/*
 * @Author: Json Chen
 * @Date: 2021-09-27 18:49:00
 * @LastEditTime: 2022-06-15 17:36:09
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/SubscriptionBuy/Detail/BasicInfo/index.tsx
 */
import CountWords from '@/src/components/CountWords/CountWords';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Row from '@/src/components/Layouts/Row/Row';
import { get } from 'lodash';
import React from 'react';
import { Form, Input } from 'src/components/Antd';
import ApplicableCurrencySelect from 'src/components/ApplicableCurrencySelect';
import { useI18n } from 'src/hooks/useRouterChange';
import { useParams } from 'react-router';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
const Item = Form.Item;
{
  /* <CountWords count={(title || '').length} allCount={100} />; */
}

interface IParams {
  uuid: string;
  discountUuid: string;
}

const BasicInfo = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { disableEdit } = props;
  const params = useParams<IParams>();
  const { uuid } = params;
  return (
    <SectionWrapper
      title={getI18n(
        'salesChannelSubscriptionBuy.basicInfo.subscriptionBuyBasicInformation',
      )}>
      <Row
        elements={[
          {
            child: (
              <React.Fragment>
                <ItemWrapper
                  title={`${getI18n(
                    'salesChannelSubscriptionBuy.basicInfo.subscriptionBuyName',
                  )}*`}
                  rightSubTitle={getI18n(
                    'salesChannelSubscriptionBuy.basicInfo.forinternalreference',
                  )}
                  rightPart={
                    <Item noStyle dependencies={['name']}>
                      {({ getFieldValue }) => (
                        <CountWords
                          count={(getFieldValue('name') || '').length}
                          allCount={100}
                        />
                      )}
                    </Item>
                  }>
                  <Input
                    size='large'
                    maxLength={100}
                    disabled={disableEdit}
                    formProps={{
                      name: 'name',
                      rules: [
                        {
                          required: true,
                          message: getI18n(
                            'salesChannelSubscriptionBuy.basicInfo.pleasefillthename',
                          ),
                        },
                      ],
                    }}
                  />
                </ItemWrapper>
              </React.Fragment>
            ),
          },
          { child: <React.Fragment /> },
        ]}
      />

      <Row
        elements={[
          {
            child: (
              <ItemWrapper
                title={`${getI18n(
                  'salesChannelSubscriptionBuy.subscriptionBuy.description',
                )}`}
                rightSubTitle={`${getI18n(
                  'salesChannelSubscriptionBuy.subscriptionBuy.descriptionTip',
                )}`}
                rightPart={
                  <Item
                    noStyle
                    shouldUpdate={(p, c) => {
                      const pV = get(p, 'subscriptionDescription');
                      const cV = get(c, 'subscriptionDescription');
                      return cV !== pV;
                    }}>
                    {({ getFieldValue }) => {
                      const name = getFieldValue('subscriptionDescription');

                      return (
                        <CountWords
                          count={(name || '').length}
                          allCount={100}
                        />
                      );
                    }}
                  </Item>
                }>
                <Input
                  size='large'
                  maxLength={100}
                  disabled={disableEdit}
                  formProps={{
                    name: 'subscriptionDescription',
                    // rules: [
                    //   {
                    //     required: true,
                    //     message: getI18n('general.fieldCannotEmpty'),
                    //   },
                    // ],
                  }}
                />
              </ItemWrapper>
            ),
          },
          { child: <React.Fragment /> },
        ]}
      />

      <Row
        elements={[
          {
            child: (
              <ItemWrapper
                title={`${getI18n(
                  'salesChannelSubscriptionBuy.basicInfo.payUpfrontPromoText',
                )}`}
                rightSubTitle={getI18n('general.optional')}
                rightPart={
                  <Item
                    noStyle
                    shouldUpdate={(p, c) => {
                      const pV = get(p, 'payUpFrontPromo');
                      const cV = get(c, 'payUpFrontPromo');
                      return cV !== pV;
                    }}>
                    {({ getFieldValue }) => {
                      const payUpFrontPromo = getFieldValue('payUpFrontPromo');

                      return (
                        <CountWords
                          count={(payUpFrontPromo || '').length}
                          allCount={100}
                        />
                      );
                    }}
                  </Item>
                }>
                <Input
                  size='large'
                  maxLength={100}
                  disabled={disableEdit}
                  formProps={{
                    name: 'payUpFrontPromo',
                    // rules: [
                    //   {
                    //     required: true,
                    //     message: getI18n('general.pleasefillthename'),
                    //   },
                    // ],
                  }}
                />
              </ItemWrapper>
            ),
          },
          { child: <React.Fragment /> },
        ]}
      />
      <Row
        elements={[
          {
            child: (
              <ItemWrapper
                title={`${getI18n(
                  'salesChannelSubscriptionBuy.basicInfo.recurringPaymentPromoText',
                )}`}
                rightSubTitle={getI18n('general.optional')}
                rightPart={
                  <Item
                    noStyle
                    shouldUpdate={(p, c) => {
                      const pV = get(p, 'recurringPaymentPromo');
                      const cV = get(c, 'recurringPaymentPromo');
                      return cV !== pV;
                    }}>
                    {({ getFieldValue }) => {
                      const name = getFieldValue('recurringPaymentPromo');

                      return (
                        <CountWords
                          count={(name || '').length}
                          allCount={100}
                        />
                      );
                    }}
                  </Item>
                }>
                <Input
                  size='large'
                  maxLength={100}
                  disabled={disableEdit}
                  formProps={{
                    name: 'recurringPaymentPromo',
                  }}
                />
              </ItemWrapper>
            ),
          },
          { child: <React.Fragment /> },
        ]}
      />

      <Row
        elements={[
          {
            child: (
              <ItemWrapper title={`${getI18n('general.applicableCurrency')}*`}>
                <Item
                  name='currencyCode'
                  rules={[
                    {
                      required: true,
                      message: replaceI18nVariables(
                        getI18n(`general.fieldisrequired`),
                        getI18n('general.currency'),
                      ),
                    },
                  ]}>
                  <ApplicableCurrencySelect
                    salesChannelUuid={uuid}
                    disabled={disableEdit}
                  />
                </Item>
              </ItemWrapper>
            ),
          },
          { child: <React.Fragment /> },
        ]}
      />
    </SectionWrapper>
  );
};
export default BasicInfo;
